<template>
  <section>
    <vue-headful
      :title="$t('TITLE_TYPE', { type: $tc('MANUFACTURER', 2) }) | formatTitle"
    ></vue-headful>
    <manufacturer-list></manufacturer-list>

    <article class="manufacturers__route">
      <router-view></router-view>
    </article>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
article.manufacturers__route {
  height: 100%;
}
</style>

<script>
// @flow
import ManufacturerList from './ManufacturerList'

export default {
  name: 'manufacturers',
  components: { ManufacturerList }
}
</script>
